import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { OneTrustCookieSettingsButton } from '@grandvisionhq/cookie-consent';

const FooterLinks = ({ items  })=>{
    var ref;
    return /*#__PURE__*/ React.createElement("ul", {
        className: "footer__links"
    }, items.map((item, index)=>{
        var ref1;
         return React.createElement("li", {
            key: `footer-link-${index}`,
            className: "footer__links-item"
        }, /*#__PURE__*/ React.createElement(Link, {
            className: "footer__link",
            url: (ref = (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref !== void 0 ? ref : '#',
            label: item.label
        }));
    }), /*#__PURE__*/ React.createElement("li", {
        className: "footer__links-item"
    }, /*#__PURE__*/ React.createElement(OneTrustCookieSettingsButton, {
        className: "footer__link"
    })));
};

export { FooterLinks, FooterLinks as default };
//# sourceMappingURL=FooterLinks.js.map
